import { Injectable } from '@angular/core';
import { Ticket } from './ticket.model';

// Services
import { AuthService } from './auth.service';
import { MailService } from './mail.service';

// Firebase
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';

// RxJS
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { tick } from '@angular/core/testing';

@Injectable({
    providedIn: 'root',
})
export class TicketService {
    private ticketCollection: AngularFirestoreCollection<any>;
    tickets$: Observable<Ticket[]>;

    private filteredTicketCollection: AngularFirestoreCollection<any>;
    allTickets$: Observable<Ticket[]>;
    filteredTickets$: Observable<Ticket[]>;

    uploadPercent: Observable<any>;

    // admin panel variables
    showClosedTickets: boolean = false;
    filterSearchterm: string = "";
    activeTicket: any = null;

    // admin panel filter functions
    toggleCheckbox() {
        this.showClosedTickets = !this.showClosedTickets;
        this.filterCheckbox();
    }

    filterCheckbox() {
        if(!this.showClosedTickets) {
            this.filteredTickets$ = this.filteredTickets$.pipe(
                map(tickets => tickets.filter(ticket => ticket.open == true)),
            )
        } else {
            this.filteredTickets$ = this.allTickets$;
        }
    }

    searchtermChanged() {
        // lower case searchterm
        let searchterm = this.filterSearchterm.toLowerCase();
        // check if searchterm not empty
        if(searchterm) {
            this.filteredTickets$ = this.filteredTickets$.pipe(
                map(tickets => 
                    tickets.filter(ticket =>
                        ticket.creator.toLowerCase().indexOf(searchterm) !== -1 || ticket.name.toLowerCase().indexOf(searchterm) !== -1
                    )    
                )
            )
        } else {
            this.filteredTickets$ = this.allTickets$;
            this.filterCheckbox();
        }
    }

    constructor(
        private afs: AngularFirestore,
        private auth: AuthService,
        private storage: AngularFireStorage,
        private mail: MailService
    ) {
        this.auth.user$.subscribe((user) => {
            if (user?.uid) {
                // personal tickets
                this.ticketCollection = this.afs.collection<any>('tickets', (ref) =>
                    ref.where('uid', '==', user?.uid)
                );
                this.tickets$ = this.ticketCollection.valueChanges();

                // filtered tickets
                this.filteredTicketCollection = this.afs.collection<any>('tickets', (ref) =>
                    ref.orderBy('createdAt', 'asc')
                );
                this.allTickets$ = this.filteredTicketCollection.valueChanges();
                this.filteredTickets$ = this.filteredTicketCollection.valueChanges();
                this.filterCheckbox();
            } else {
                this.ticketCollection = null;
                this.tickets$ = null;
                this.filteredTicketCollection = null;
                this.filteredTickets$ = null;
            }
        });
    }

    async setActiveTicket(tid?) {
        if(tid) {
            this.filteredTicketCollection.doc(tid).get().subscribe(ticket => {
                this.activeTicket = ticket.data();
                console.log(ticket.data())
            })
        } else {
            this.activeTicket = null;
        }

    }

    closeTicket(tid) {
        this.ticketCollection.doc(tid).update({ open: false });
    }

    reopenTicket(tid) {
        this.ticketCollection.doc(tid).update({ open: true });
    }

    async addTicket(data, files?) {
        // create vars
        const id = this.afs.createId();
        const images = [];
        // handle file upload
        let imagePromises = [];
        if (files) {
            for (let i = 0; i < files.length; i++) {
                const date = Math.round(new Date().getTime() / 1000);
                const filePath = data.uid + '/' + date + '-' + i;
                const fileRef = this.storage.ref(filePath);
                const task = this.storage.upload(filePath, files[i]);
                // get upload percet
                this.uploadPercent = task.percentageChanges();
                // add image infos to array

                let prom = task
                .snapshotChanges()
                .toPromise()
                .then(async () => {
                    let url = await fileRef.getDownloadURL().toPromise();

                    let image = {
                    name: date + '-' + i,
                    path: filePath,
                    url: url,
                    };
                    return images.push(image);
                });
                imagePromises.push(prom);
            }
        }

        await Promise.all(imagePromises);
        // create Ticket
        const ticket: Ticket = {
            tid: id,
            open: true,
            createdAt: data.createdAt,
            uid: data.uid,
            creator: data.creator,
            name: data.name,
            category: data.category,
            description: data.description,
            address: data.address,
            images: images,
        };

        // upload Ticket
        this.ticketCollection.doc(id).set(ticket);

        // send mail
        const payload = {
            tid: id,
            uid: data.uid,
            creator: data.creator,
            mail: data.mail,
            phone: data.phone,
            name: data.name,
            category: data.category,
            description: data.description,
            address: data.address,
            images: images,
        };
        this.mail.sendMail(payload);

    }
}
